import type { IconData } from '@stacksjs/iconify-core'

export const angleLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M14.121 17.243a1 1 0 0 1-.707-.293l-4.242-4.243a1 1 0 0 1 0-1.414l4.242-4.243a1 1 0 0 1 1.414 1.414L11.293 12l3.535 3.536a1 1 0 0 1-.707 1.707\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default angleLeft
